module.exports = __webpack_public_path__ + "static/media/pin-maps.454d14cd.svg";